import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeparatorWetScrubber = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 120,
	viewBox: "0 0 80.0 120.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 80.0 0.0 L 80.0 80.0 L 40.0 120.0 L 0.0 80.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 40.0 10.0 L 40.0 65.0 M 50.0 10.0 A 5.0 5.0 0.0 1 0 60.0 10.0 M 60.0 10.0 A 5.0 5.0 0.0 1 0 70.0 10.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 38.0 65.0 L 42.0 65.0 L 40.0 70.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgSeparatorWetScrubber;
